// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Box, Grid2, Stack, Typography } from '@mui/material';
// Components, Layouts, Pages
import { BaseCheckbox } from '~/components/common';
// Others
import { formatCurrencyUSD } from '~/utils/helper/common';
import { IInventoryDetail, IProductAddOn } from '~/utils/interface/inventory';
// Styles, images, icons
import styles from './AddOnProductDetail.module.scss';

type Props = {
  detailProduct?: IInventoryDetail;
};

const cx = classNames.bind(styles);

const AddOnProductDetail = (props: Props) => {
  //#region Destructuring Props
  const { detailProduct } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/inventory', 'common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const renderAddOneItem = (item: IProductAddOn, index: number) => {
    return (
      <Grid2 size={4} key={index} className={cx('itemAddOn')}>
        <Stack gap={3}>
          <Stack direction={'row'} alignItems={'center'} gap={2}>
            <Box className={cx('dot')} />
            <Typography className={cx('textName')}>{item.name}</Typography>
          </Stack>

          <Stack gap={2}>
            <Typography className={cx('textValue')}>{`${t(
              'inventory_detail_title_rental_price_label'
            )} ${formatCurrencyUSD({ value: item.originRentalPrice, showDecimal: true })}`}</Typography>
            <Typography className={cx('textValue')}>{`${t('inventory_detail_title_quantity_label')} ${
              item.addOnQuantity
            } ${t(
              Number(item.addOnQuantity) > 1 ? 'inventory_detail_title_units' : 'inventory_detail_title_unit'
            )}`}</Typography>

            <Typography className={cx('textValue')}>{`${t('inventory_detail_title_variants_label')} ${item.variants
              .map((item) => item.name)
              .join(', ')}`}</Typography>
          </Stack>

          <BaseCheckbox
            type='small'
            label={t(item.isRequired ? 'inventory_detail_title_required' : 'inventory_detail_title_optional')}
            checked={item.isRequired}
          />
        </Stack>
      </Grid2>
    );
  };
  //#endregion Handle Function

  return (
    <Stack id='addOnProductDetailComponent' gap={6} className={cx('container')}>
      <Typography className={cx('textHeader')}>{t('inventory_detail_title_add_on_products')}</Typography>

      <Grid2 container spacing={4}>
        {detailProduct && detailProduct.addOns.length > 0 ? (
          detailProduct.addOns.map((item, index) => {
            return renderAddOneItem(item, index);
          })
        ) : (
          <Typography align='center' className={cx('noData')}>
            {t('common_no_data_available', { ns: 'common/base' })}
          </Typography>
        )}
      </Grid2>
    </Stack>
  );
};

export default AddOnProductDetail;
